// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    padding: 0;
    font-family: sans-serif;

}

html, body {
    height: 100%;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance: textfield; /* Firefox */
}

.main-container {
    min-height: 100vh; /* will cover the 100% of viewport */
    overflow: hidden;
    display: block;
    position: relative;
    /*padding-bottom: 100px; !* height of your footer *!*/

}

.dcf-lightbox {
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(0, 0, 0, .75) !important;
}

@media screen and (min-width: 481px), screen and (min-height: 669px) {
    #container {
        max-width: 375px !important;
        height: 668px !important;
        margin: 0 auto;
        /*box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.22), 0 22px 22px 0 rgba(0, 0, 0, 0.3);*/
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: auto;
        background: white;
    }
}

@media screen and (max-width: 480px), screen and (max-height: 668px) {
    #container {
        max-width: 100% !important;
        height: 100% !important;
        margin: 0 auto;
        /*box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.22), 0 22px 22px 0 rgba(0, 0, 0, 0.3);*/
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow: auto;
        background: white;

    }
}

.centred-div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#frame-div{
    position: fixed;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    z-index: 1000000;
}

#phoneNumber {
    min-height: unset;
}`, "",{"version":3,"sources":["webpack://./src/client/index.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,8CAA8C;IAC9C,wBAAwB;IACxB,SAAS,EAAE,uEAAuE;AACtF;;AAEA;IACI,0BAA0B,EAAE,YAAY;AAC5C;;AAEA;IACI,iBAAiB,EAAE,oCAAoC;IACvD,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qDAAqD;;AAEzD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,+CAA+C;AACnD;;AAEA;IACI;QACI,2BAA2B;QAC3B,wBAAwB;QACxB,cAAc;QACd,gFAAgF;QAChF,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,cAAc;QACd,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,uBAAuB;QACvB,cAAc;QACd,gFAAgF;QAChF,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,cAAc;QACd,iBAAiB;;IAErB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["body {\n    padding: 0;\n    font-family: sans-serif;\n\n}\n\nhtml, body {\n    height: 100%;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n\ninput[type=number] {\n    -moz-appearance: textfield; /* Firefox */\n}\n\n.main-container {\n    min-height: 100vh; /* will cover the 100% of viewport */\n    overflow: hidden;\n    display: block;\n    position: relative;\n    /*padding-bottom: 100px; !* height of your footer *!*/\n\n}\n\n.dcf-lightbox {\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n    background-color: rgba(0, 0, 0, .75) !important;\n}\n\n@media screen and (min-width: 481px), screen and (min-height: 669px) {\n    #container {\n        max-width: 375px !important;\n        height: 668px !important;\n        margin: 0 auto;\n        /*box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.22), 0 22px 22px 0 rgba(0, 0, 0, 0.3);*/\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        overflow: auto;\n        background: white;\n    }\n}\n\n@media screen and (max-width: 480px), screen and (max-height: 668px) {\n    #container {\n        max-width: 100% !important;\n        height: 100% !important;\n        margin: 0 auto;\n        /*box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.22), 0 22px 22px 0 rgba(0, 0, 0, 0.3);*/\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        overflow: auto;\n        background: white;\n\n    }\n}\n\n.centred-div {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n#frame-div{\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    z-index: 1000000;\n}\n\n#phoneNumber {\n    min-height: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
